import React from 'react'

// STYLES
import styled from 'styled-components'

const Title = ({color, text, className}) => <h2 className={className}>{text}</h2>

const TitleWithStyles = styled(Title)`
    color: ${(props) => (props.color ? props.color : '#66666')};
    font-family: Dosis;
    font-size: 36px;
    font-weight: 300;
    line-height: 46px;
    text-align: center;
    text-shadow: 0 1px 10px 0 rgba(0,0,0,0.3);
    margin-top: 0;
    margin-bottom: 25px;
`

export default TitleWithStyles



// WEBPACK FOOTER //
// ./src/components/title/title.component.js